/**
 * 这里记录了全局通用的枚举，如 ad_type network_type 等
 */

export const AD_TYPE = {
    RV: 94,
    IV: 287,
}